import { Component, EventEmitter, Output, Renderer2, inject } from '@angular/core';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { IconsModule } from '@progress/kendo-angular-icons';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { ListViewModule } from '@progress/kendo-angular-listview';
import { SVGIcon, xIcon, checkIcon, arrowLeftIcon, lockIcon, userIcon, gearIcon } from '@progress/kendo-svg-icons';
import { BaseComponent } from '../../../../shared/common/base.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-vip-support',
  standalone: true,
  imports: [ButtonsModule, ListViewModule, LayoutModule, IconsModule, CommonModule],
  templateUrl: './vip-support.component.html',
  styleUrl: './vip-support.component.scss',
})
export class VipSupportComponent extends BaseComponent {
  @Output() close = new EventEmitter<void>();
  public xIcon: SVGIcon = xIcon;
  public checkIcon: SVGIcon = checkIcon;
  public arrowLeftIcon: SVGIcon = arrowLeftIcon;
  public lockIcon: SVGIcon = lockIcon;
  public userIcon: SVGIcon = userIcon;
  public gearIcon: SVGIcon = gearIcon;
  public infoIcon: SVGIcon = checkIcon;
  private renderer = inject(Renderer2);
  public showBackButton = false;

  constructor() {
    super();
  }

  ngAfterViewInit(): void {
    // Component initialized, DOM elements available
  }

  navigateToSection(section: string): void {
    this.showBackButton = true;
    setTimeout(() => {
      this.loadRoamLobby(section);
    }, 100);
  }

  showLobbyButtons(): void {
    this.showBackButton = false;
    const roamElement = document.getElementById('roam-lobby');
    if (roamElement) {
      roamElement.innerHTML = '';
    }
  }

  loadRoamLobby(section: string) {
    if ((window as any).Roam) {
      this.initializeRoamLobby(section);
    } else {
      const script = this.renderer.createElement('script');
      script.src = 'https://ro.am/lobbylinks/embed.js';
      script.onload = () => {
        this.initializeRoamLobby(section);
      };
      script.onerror = () => {
        console.error('Failed to load Roam script');
      };
      document.body.appendChild(script);
    }
  }

  private initializeRoamLobby(section: string) {
    const parentElement = document.getElementById('roam-lobby');
    if (parentElement) {
      const url = `https://ro.am/cyflarehq/${section.toLowerCase()}/`;
      (window as any).Roam.initLobbyEmbed({
        url,
        parentElement,
        lobbyConfiguration: 'default',
        theme: 'dark',
        onSizeChange: (width: number, height: number) => {
          if (parentElement) {
            parentElement.style.height = `${height}px`;
          }
        },
      });
    } else {
      console.error('Parent element for Roam widget not found');
    }
  }

  public cancel() {
    this.close.emit();
  }
}
